import React from "react";
import { DescriptionBox } from "./DescriptionBox";
import "./Step.css"; // 必要に応じてCSSファイルをインポート

/**
 * 手順コンポーネント
 * @param {Object} props - プロパティ
 * @param {string} props.step - 手順番号
 * @param {React.ReactNode} props.text - 手順の説明
 * @param {string} [props.image] - 手順の画像
 * @param {string} [props.alt] - 画像の代替テキスト
 * @param {React.ReactNode} [props.point_text] - 補足説明
 * @param {string} [props.point_image] - 補足説明の画像
 * @param {string} [props.point_alt] - 補足説明の画像の代替テキスト
 * @returns {JSX.Element} 手順のJSX要素
 */
export const Step: React.FC<{
  step: string;
  text: React.ReactNode;
  image?: string;
  alt?: string;
  point_text?: React.ReactNode;
  point_image?: string;
  point_alt?: string;
}> = ({ step, text, image, alt, point_text, point_image, point_alt }) => (
  <p className="c-text">
    {step} {text}
    {image && (
      <>
        <br />
        <img src={image} alt={alt} className="step-image" />
      </>
    )}
    {point_text && <DescriptionBox description={point_text} image={point_image} alt={point_alt} />}
  </p>
);
